import { render, staticRenderFns } from "./AddUserPermission.vue?vue&type=template&id=64682722&scoped=true&"
import script from "./AddUserPermission.vue?vue&type=script&lang=js&"
export * from "./AddUserPermission.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64682722",
  null
  
)

export default component.exports